import { NumericFormat, NumericFormatProps } from 'react-number-format';
import TextField, { TTextFieldProps } from '../TextField';

export interface INumericTextFieldBaseProps extends Omit<
  TTextFieldProps, 'type' | 'value' | 'defaultValue'
> {
  type?: 'text' | 'password';
  value?: string | number | null;
  defaultValue?: string | number | null;
}

export interface INumericTextFieldProps extends INumericTextFieldBaseProps, Pick<
  NumericFormatProps, 'thousandSeparator' | 'decimalSeparator' | 'allowNegative'
> {}

const NumericTextField = (props: INumericTextFieldProps) => (
  <NumericFormat customInput={TextField} {...props} />
);

export default NumericTextField;
